module.exports = __webpack_public_path__ + "static/media/Huawei P8 White.90af8ae8.png";